<template>
  <section class="dp-layout">
    <section class="dp-right op-page">
    <header class="op-page__head">
      <div>
        <div class="op-page__eyebrow">Access observability</div>
        <h3 class="op-page__title">接口调用日志</h3>
        <p class="op-page__desc">查看合作方接口访问、耗时和业务结果。日志仅保留脱敏摘要，不记录令牌、密钥或完整手机号。</p>
      </div>
      <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新日志</el-button>
    </header>

    <div class="toolbar-filter-bar">
    <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
      <div class="toolbar-filter-fields">
      <el-form-item label="时间">
        <el-date-picker v-model="dateRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
         start-placeholder="开始" end-placeholder="结束"
          :default-time="['00:00:00','23:59:59']" class="toolbar-field-w-xl" />
      </el-form-item>
      <el-form-item label="学校编号">
        <el-input v-model="filters.schoolDepartmentId" clearable class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="应用标识">
        <el-input v-model="filters.appKey" clearable class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="路径">
        <el-input v-model="filters.path" clearable class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="状态码">
        <el-input v-model="filters.httpStatus" clearable class="toolbar-field-w-xs" />
      </el-form-item>
      <el-form-item label="业务码">
        <el-input v-model="filters.bizCode" clearable class="toolbar-field-w-xs" />
      </el-form-item>
      <el-form-item label="请求编号">
        <el-input v-model="filters.requestId" clearable class="toolbar-field-w-xl" />
      </el-form-item>
      <el-form-item label="追踪编号">
        <el-input v-model="filters.traceId" clearable class="toolbar-field-w-xl" />
      </el-form-item>
      <el-form-item label="耗时≥">
        <el-select v-model="filters.minDurationMs" clearable placeholder="全部" class="toolbar-field-w-sm">
          <el-option label="≥300毫秒" :value="300" />
          <el-option label="≥1秒" :value="1000" />
          <el-option label="≥3秒" :value="3000" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </el-form-item>
      </div>
      <div class="toolbar-filter-actions">
        <el-button size="small" type="info" icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
      </div>
    </el-form>
    </div>

    <div class="tbl-scroll-host">
    <el-table :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无日志"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column prop="CreateTime" label="时间" width="168" />
      <el-table-column prop="DurationMs" label="耗时" width="90" align="right">
        <template slot-scope="scope">{{ scope.row.DurationMs }}毫秒</template>
      </el-table-column>
      <el-table-column prop="HttpMethod" label="方法" width="70" />
      <el-table-column prop="Path" label="路径" min-width="280" show-overflow-tooltip />
      <el-table-column prop="HttpStatus" label="状态码" width="80" align="center" />
      <el-table-column prop="BizCode" label="业务码" width="80" align="center" />
      <el-table-column prop="SchoolId" label="学校" min-width="150" show-overflow-tooltip />
      <el-table-column prop="RequestId" label="请求编号" min-width="220" show-overflow-tooltip />
      <el-table-column prop="ClientIp" label="客户端地址" width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="showDetail(scope.row)">摘要</el-button>
          <el-button v-if="scope.row.RequestId" type="text" size="mini" @click="goSync(scope.row)">同步任务</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, prev, pager, next" :current-page.sync="page" :page-size="pageSize"
        :total="total" style="float: right" @current-change="load" />
    </el-col>

    <el-dialog title="请求摘要" :visible.sync="detailVisible" width="640px" custom-class="op-detail-dialog">
      <template v-if="current">
        <el-descriptions :column="1" size="small" border>
          <el-descriptions-item label="时间">{{ current.CreateTime || '—' }}</el-descriptions-item>
          <el-descriptions-item label="方法 / 路径">{{ current.HttpMethod }} {{ current.Path }}</el-descriptions-item>
          <el-descriptions-item label="状态码 / 业务码">{{ current.HttpStatus }} / {{ current.BizCode }}</el-descriptions-item>
          <el-descriptions-item label="耗时">{{ current.DurationMs }} 毫秒</el-descriptions-item>
          <el-descriptions-item label="请求编号">{{ current.RequestId || '—' }}</el-descriptions-item>
          <el-descriptions-item label="追踪编号">{{ current.TraceId || '—' }}</el-descriptions-item>
          <el-descriptions-item label="批量编号">{{ current.BatchId || '—' }}</el-descriptions-item>
          <el-descriptions-item label="客户端地址">{{ current.ClientIp || '—' }}</el-descriptions-item>
        </el-descriptions>
        <div class="op-block">
          <div class="op-block__title">脱敏摘要</div>
          <el-descriptions v-if="summaryRows.length" :column="1" size="small" border>
            <el-descriptions-item v-for="row in summaryRows" :key="row.label" :label="row.label">
              {{ row.value }}
            </el-descriptions-item>
          </el-descriptions>
          <pre v-else class="op-code">{{ current.ParamSummary || '无摘要' }}</pre>
        </div>
      </template>
      <div slot="footer">
        <el-button type="primary" @click="detailVisible = false">知道了</el-button>
      </div>
    </el-dialog>
    </section>
  </section>
</template>

<script>
import { getPartnerAccessLogPage } from '@/api/modules/openPlatform';
import { parseKvSummary } from '@/utils/openPlatformLabels';

export default {
  name: 'ApiAccessLog',
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dateRange: [],
      filters: {},
      detailVisible: false,
      current: null
    };
  },
  computed: {
    summaryRows() {
      return parseKvSummary(this.current && this.current.ParamSummary);
    }
  },
  created() {
    this.load();
  },
  methods: {
    handleSearch() {
      this.page = 1;
      this.load();
    },
    handleReset() {
      this.filters = {};
      this.dateRange = [];
      this.handleSearch();
    },
    buildParams() {
      const params = { page: this.page, pageSize: this.pageSize, ...this.filters };
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      Object.keys(params).forEach(k => {
        if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k];
      });
      return params;
    },
    load() {
      this.loading = true;
      getPartnerAccessLogPage(this.buildParams()).then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.tableData = page.data || [];
          this.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败');
        }
      }).catch(() => { this.loading = false; });
    },
    showDetail(row) {
      this.current = row;
      this.detailVisible = true;
    },
    goSync(row) {
      this.$router.push({
        path: '/OpenPlatform/SyncTaskCenter',
        query: { requestId: row.RequestId }
      });
    }
  }
};
</script>

<style scoped>
.op-block { margin-top: 14px; }
.op-block__title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid var(--btn-primary, #2563eb);
}
.op-code {
  margin: 0;
  padding: 12px 14px;
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 6px;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
